<template>
  <div class="container">
    <!-- 搜索表单 -->
    <el-form
      :model="searchFormData"
      ref="searchFormRef"
      label-width="100px"
      class="search-form"
      :inline="true"
      @submit.prevent="handleSearch"
    >
      <el-form-item label="设备ID">
        <el-input
          v-model="searchFormData.device_id"
          placeholder="请输入设备ID"
          clearable
        />
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input
          v-model="searchFormData.user_id"
          placeholder="请输入用户ID"
          clearable
        />
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="searchFormData.created_at"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          clearable
          value-format="YYYY-MM-DD"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-form-item>
    </el-form>

    <!-- 列表 -->
    <el-table
      :data="devices"
      style="width: 100%"
      v-loading="loading"
      :header-cell-style="{ background: '#f5f7fa' }"
    >
      <el-table-column type="index" label="序号" width="80" />
      <el-table-column prop="user_id" label="用户ID" min-width="80" />
      <el-table-column prop="user_nickname" label="用户昵称" min-width="160" />
      <el-table-column
        prop="device_id"
        label="设备ID (设备mac)"
        min-width="150"
      />
      <!-- <el-table-column prop="device_name" label="设备名称" min-width="120" /> -->
      <el-table-column prop="created_at" label="创建时间" min-width="160" />
      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button size="small" @click="handleDetail(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      style="margin-top: 20px; text-align: right"
      background
      layout="prev, pager, next, jumper, ->, total"
      :total="total"
      :page-size="pageSize"
      v-model:current-page="currentPage"
      @current-change="handlePageChange"
    />

    <!-- 留言板详情对话框 -->
    <el-dialog
      v-model="detailDialogVisible"
      title="留言板详情"
      width="600px"
      destroy-on-close
    >
      <el-form
        :model="currentDeviceBoard"
        label-width="120px"
        v-loading="detailLoading"
      >
        <el-form-item label="设备ID:">
          <span>{{ currentDeviceBoard.device_id }}</span>
        </el-form-item>
        <el-form-item label="留言板内容:">
          <span>{{ currentDeviceBoard.content }}</span>
        </el-form-item>
        <el-form-item label="创建时间:">
          <span>{{ currentDeviceBoard.created_at }}</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted } from "vue";
import { getDeviceBoards, getDeviceBoardById } from "@/api/deviceBoard";
import { ElMessage } from "element-plus";

// 搜索表单数据
const searchFormData = reactive({
});

// 搜索表单引用
const searchFormRef = ref(null);


// 处理搜索
const handleSearch = () => {
  // 执行搜索逻辑
  console.log("搜索参数:", searchFormData);
  currentPage.value = 1;
  fetchData();
};

// // 重置搜索
// const resetSearch = () => {
//   // 清空搜索条件
//   searchFormData.device_id = "";
//   searchFormData.user_id = "";
//   searchFormData.created_at = [];
//   // 重新加载数据
//   fetchData();
// };

// 获取留言板列表方法（示例）
const devices = ref([]);
const loading = ref(false);
const total = ref(0);
const pageSize = ref(10);
const currentPage = ref(1);

const fetchData = async () => {
  try {
    loading.value = true;
    const params = {
      page: currentPage.value,
      page_size: pageSize.value,
      ...searchFormData,
    };
    if(searchFormData.created_at && searchFormData.created_at.length === 2){
      params.start_time = searchFormData.created_at[0] + " 00:00:00";
      params.end_time = searchFormData.created_at[1] + " 23:59:59";
    }

    const response = await getDeviceBoards(params);
    devices.value = response.data || [];
    total.value = response.total || 0;
  } catch (error) {
    console.error("加载留言板列表失败:", error);
    ElMessage.error("加载留言板列表失败");
  } finally {
    loading.value = false;
  }
};

// 页面切换处理
const handlePageChange = (page) => {
  currentPage.value = page;
  fetchData();
};

// 详情对话框相关
const detailDialogVisible = ref(false);
const detailLoading = ref(false);
const currentDeviceBoard = ref({});

// 查看详情
const handleDetail = async (row) => {
  detailDialogVisible.value = true;
  detailLoading.value = true;
  try {
    const response = await getDeviceBoardById(row.id);
    if (response.success) {
      currentDeviceBoard.value = response.data || {};
    } else {
      ElMessage.error(response.message || "获取详情失败");
      detailDialogVisible.value = false;
    }
  } catch (error) {
    console.error("获取详情失败:", error);
    ElMessage.error("获取详情失败");
    detailDialogVisible.value = false;
  } finally {
    detailLoading.value = false;
  }
};

onMounted(() => {
  fetchData();
});
</script>

<style lang="css" scoped>
.search-form {
  background-color: #f5f7fa;
  margin-bottom: 20px;
  border-radius: 4px;
}
</style>